import { apiCall } from "./authServieces";

export const getPaymentStatusFromAPI = async (id) => {
    const response = await apiCall({
        endpoint: `api/pg/get-payment-status/${id}`,
        method: "GET",
    });
    return response;
}